// @flow
import endsWith from "./ends_with";

export default (conditionValue: any) => (fieldValue: any) =>
  !endsWith(conditionValue)(fieldValue);
